window.casino = window.casino || {};
var repos = window.casino.repos = window.casino.repos || {};

repos.gameDetailsRepo = function () {
    const get = function (sifraIgre) {
        let url = 'api/gamedetails?c=' + casino.config.guiCacheVerzija;
        url = url + '&sifraigre=' + sifraIgre;

        return fetch(url, {
            method: 'GET',
        }).then(function (response) {
            return response.json();
        });
    };

    return {
        get: get,
    }
}();